import { Component, Input, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
import { GraficoTramitacion } from '../../models/graficoTramitacion.model';

@Component({
  selector: 'app-dash-tramitacion',
  templateUrl: './dash-tramitacion.component.html',
  styleUrls: ['./dash-tramitacion.component.scss']
})
export class DashTramitacionComponent implements OnInit {
  @Input() datos: GraficoTramitacion;
  public polarAreaChartLabels = [];
  public polarAreaChartData = [];
  public polarAreaLegend = true;
  lineChartOptions = {
   responsive: true,
     legend: {
         display: true,
         position: 'left', 
       }
 };
  public polarAreaChartType: ChartType = 'polarArea';
  constructor() { 
    
    // this.datos={
    // titulo:'asd',
    // data:[],
    // descripciones:[],
    // fechaUltimoCalculo: new Date()
    // }
  }

  ngOnInit() {
    this.polarAreaChartData=this.datos.data;
    this.polarAreaChartLabels=this.datos.descripciones;
  }

   // PolarArea0

   // events
   public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

}
